import React, {Component} from 'react';
import EditableTooltip from 'src/components/editable-tooltip/tooltip';
import {Col, Dropdown, Icon, Menu, Modal, Row, Spin} from 'antd';
import autobind from 'autobind-decorator';
import {withTranslation, WithTranslation} from 'react-i18next'
import TextArea from 'antd/lib/input/TextArea';

export interface CellData {
    value: any
}

export interface RowData {
    key: string | number | undefined,
    title: string
    cells: CellData[]
}

export interface RowsDataSource {
    items: RowData[],
    title: string
    render: (item: CellData) => React.ComponentElement<any, any>
}

export interface ColumnCell {
    key: string | number | undefined
    value: any
}

export interface ColumnsSource {
    items: ColumnCell[]
    render: (item: ColumnCell) => React.ComponentElement<any, any>
}

export interface TableData {
    columnsSource: ColumnsSource,
    rowsSource: RowsDataSource,
}

interface SimpleTableViewProps extends WithTranslation {
    data: TableData
    onDownload?: (formats: string) => Promise<boolean>,
    downloadTypeStandard?: string,
    downloadTypeMatrix?: string,
    showBar?: boolean,
    showPie?: boolean,
    elegibility?: boolean,
    refresh?: boolean,
    onRefresh?: () => void,

}

interface SimpleTableViewState {
    data: TableData
    isBusy: boolean,
    showConfirmModal: boolean
}

class SimpleViewTable extends Component<SimpleTableViewProps, SimpleTableViewState> {
    constructor(props: SimpleTableViewProps) {
        super(props);
        this.state = {
            data: props.data,
            showConfirmModal: false,
            isBusy: false
        }
    }

    componentDidUpdate(prev: SimpleTableViewProps) {
        if (prev.refresh != this.props.refresh) {
            this.setState({ data: this.props.data }, () => this.props.onRefresh!())
        }

    }

    @autobind
    private async onDownloadStandard() {
        if (this.props.onDownload && this.props.downloadTypeStandard)
            this.props.onDownload(this.props.downloadTypeStandard);
    }
    @autobind
    private async onDownloadMatrix() {
        if (this.props.onDownload && this.props.downloadTypeMatrix)
            this.props.onDownload(this.props.downloadTypeMatrix);
    }

    render() {
        const { t } = this.props
        var self = this

        let rowsDataSource = this.state.data.rowsSource
        let columnsSource = this.state.data.columnsSource

        const downloadOptions = <Menu>
            <Menu.Item key={'std_menu'} onClick={this.onDownloadStandard}>{t('Standard Format')}</Menu.Item>
            {!this.props.elegibility && < Menu.Item key={'std_menu'} onClick={this.onDownloadMatrix}>{t('Matrix Format')}</Menu.Item>}
        </Menu>

        return <Spin size='large' spinning={this.state.isBusy} style={{ width: "100%" }}>
            <div className='timesheet ant-table ant-table-default ant-table-bordered ant-table-scroll-position-left'>
                <div className='ant-table-content'>
                    <div className='ant-table-body'>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                            <ul className='toolbar' style={{ paddingLeft: 0, marginBottom: 5 }}>
                            </ul>
                            <ul className='toolbar' style={{ marginBottom: 5 }}>
                                {this.props.onDownload &&
                                    <EditableTooltip name='timesheet-download' noIcon>
                                        <li>
                                            <Dropdown.Button
                                                overlay={downloadOptions}>{t('Download')} <Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 5, marginLeft: 5 }} />
                                            </Dropdown.Button>
                                        </li>
                                    </EditableTooltip>}
                            </ul>
                            <Modal
                                title={t('Confirmation Message')}
                                visible={this.state.showConfirmModal}
                                okText={t('Ok')}
                                cancelText={t('Cancel')}>
                                <Row justify="center">
                                    <Col>
                                        <span>{t('Message')}</span>
                                        <TextArea
                                            value={"value"}
                                        />
                                    </Col>
                                </Row>
                            </Modal>
                        </div>
                        <div style={{ overflowX: 'auto', overflowY: 'hidden' }}>
                            <table>
                                <thead className="ant-table-thead">
                                    <tr>
                                        <th rowSpan={2}>{t(rowsDataSource.title)}</th>
                                        {columnsSource.items.map((col, index, array) => {
                                            return <th key={col.key} colSpan={rowsDataSource.items.length}> {t(col.value)} </th>
                                        })}
                                    </tr>
                                </thead>
                                <tbody className="ant-table-tbody">
                                    {rowsDataSource.items.map((row) => <tr key={row.key} className="ant-table-row">
                                        <td style={{ backgroundColor: 'transparent' }}>
                                            <span className={'timesheet-item'} style={{ padding: 5 }}> {row.title} </span>
                                        </td>
                                        {columnsSource.items.map((col, index) => {
                                            return <td key={`${row.key}${col.key}`} colSpan={rowsDataSource.items.length}>
                                                {rowsDataSource.render(row.cells[index])}
                                            </td>
                                        })
                                        }
                                    </tr>)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Spin>
    }
}
export default withTranslation()(SimpleViewTable);